<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<div *ngIf="selectedSeikyuInfo">
    <mat-card class="cur-card">
      <app-sgkd002d-basic
        [mainForm]="mainForm"
        [paramClaimCtrNo]="paramClaimCtrNo"
        [sgkd034aResponse]="response"
        (infoClick)="onClickIcon()"
      />
      <form [formGroup]="mainForm" (ngSubmit)="onSubmit()">
        <app-sgkd002d-select-pay-info
          [mainForm]="mainForm"
          [codePayMethodList]="codePayMethodList"
          [codeDptClsfyCdList]="codeDptClsfyCdList"
          [codeRecivMethodList]="codeRecivMethodList"
          [codeCreComAnameList]="codeCreComAnameList"
          [businessDate]="businessDate"
          *ngIf="loadedCodeList && loadedCompanycodeInfoList"
          (changePayMethodEvent)="clearMessage()"
        />
        <app-sgkd002d-button
          [mainForm]="mainForm"/>
      </form>
    </mat-card>
  </div>
  